import { type HttpClient } from '../http';

import { type FarewellFeedback } from './farewell.types';

/**
 * What a closed account still tells us.
 *
 * @param http Transport supplied by the application.
 * @returns The farewell domain of the API client.
 */
export function createFarewellApi(http: HttpClient) {
  return {
    /**
     * Says why an account was closed.
     *
     * ⚠️ Anonymous, and the shape is what makes it so: a reason and, at most,
     * a sentence. No address, no identifier, no token — the account this is
     * about no longer exists, and nothing here could be joined back to it.
     *
     * @param feedback The one reason chosen, and what they wrote if anything.
     */
    leave: (feedback: FarewellFeedback) =>
      http.post<void>('/farewell/feedback', feedback),
  };
}

export type FarewellApi = ReturnType<typeof createFarewellApi>;
